import { RELAY_POLICY_TYPES } from '../services/apollo-relay.service';

const DEFAULT_MERGE = (existing, incoming) => incoming;
const DEFAULT_READ = (existing, _a) => existing;
const CUSTOM_FIELD_POLICIES = {};

export const createTypePolicyFields = () => {
  return RELAY_POLICY_TYPES.reduce((policies, type) => {
    const customField = CUSTOM_FIELD_POLICIES[type];

    if (customField) {
      policies[type] = customField;
    } else {
      policies[type] = {
        merge: DEFAULT_MERGE,
        read: DEFAULT_READ
      };
    }

    return policies;
  }, {});
};
